import React, { createContext, useContext } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { configure } from './configure';
var createRouter = function (routeConfig) {
    var routes = configure(routeConfig);
    var RouteContext = createContext(routes);
    var RouteProvider = function (_a) {
        var children = _a.children;
        return (React.createElement(RouteContext.Provider, { value: routes },
            React.createElement(BrowserRouter, null, children)));
    };
    var useRoute = function () { return useContext(RouteContext).routes; };
    var useDef = function () { return useContext(RouteContext).defs; };
    var usePrefix = function () { return useContext(RouteContext).prefix; };
    return {
        RouteProvider: RouteProvider,
        useRoute: useRoute,
        useDef: useDef,
        usePrefix: usePrefix,
    };
};
export default createRouter;
